import React from "react"
import AbrName from "./Display Types/display_abr_name"
import QbAts from "./Display Types/display_ats"
import Cpoe from "./Display Types/display_cpoe"
import Dist from "./Display Types/display_distribution"
import EpaComp from "./Display Types/display_epa_comp"

import AsFloat from "./Display Types/display_float"
import Gini from "./Display Types/display_gini"
import AsInt from "./Display Types/display_int"
import AmericanOdds from "./Display Types/display_odds_american"
import AsPct from "./Display Types/display_pct"
import AsPctRem from "./Display Types/display_pct_rem"
import TargetShare from "./Display Types/display_targetshare"
import TotalStatus from "./Display Types/display_total_status"
import Wins from "./Display Types/display_wins"
import QBAdj from "./Display Types/qb_adj"
import SpreadChangeStyle from "./Display Types/spread_change"
import TeamArray from "./Display Types/team_array"
import ImageArray from "./Display Types/image_array"
import ImageX from "./Display Types/display_image_x"
import BettingAts from "./Display Types/display_betting_ats"
import ActiveStatus from "./Display Types/display_active_status"
import Rank32 from "./Display Types/display_rank_32"

const CellDisplay= ({ cellContent, displayType, displayParams }) => {

    // check how cell should be displayed and return component //

    if (displayType === 'unstyled') {

        return (

            <div>
                {cellContent}
            </div>

        )

    } else if (displayType === 'QBAdj') {

        return (

            <QBAdj
                adj={cellContent}
            />
        
        )

    } else if (displayType === 'SpreadChange') {

        return (

            <SpreadChangeStyle
                adj={cellContent}
                measureType={displayParams['measureType']}
                rem={displayParams['rem']}
            />
        
        )

    } else if (displayType === 'Wins') {

        return (

            <Wins
                wins={cellContent}
            />
        
        )

    } else if (displayType === 'TargetShare') {

        return (

            <TargetShare
                tShare={cellContent}
            />
        
        )

    } else if (displayType === 'Cpoe') {

        return (

            <Cpoe
                cpoe={cellContent}
                rem={displayParams['rem']}
            />
        
        )

    } else if (displayType === 'AsInt') {

        return (

            <AsInt
                val={cellContent}
            />
        
        )

    }
    else if (displayType === 'AsFloat') {

        return (

            <AsFloat
                val={cellContent}
                percision={displayParams['percision']}
            />
        
        )

    } else if (displayType === 'AsPct') {

        return (

            <AsPct
                val={cellContent}
                percision={displayParams['percision']}
            />
        
        )

    } else if (displayType === 'AsPctRem') {

        return (

            <AsPctRem
                val={cellContent}
                percision={displayParams['percision']}
                rem={displayParams['rem']}

            />
        
        )

    } else if (displayType === 'Dist') {

        return (

            <Dist
                share={cellContent}
                max_color={displayParams['maxColor']}
                percision={displayParams['percision']}
            />
        
        )

    } else if (displayType === 'Gini') {

        return (

            <Gini
                gini={cellContent}
                percision={displayParams['percision']}
            />
        
        )

    } else if (displayType === 'EpaComp') {

        return (

            <EpaComp
                val={cellContent}
                percision={displayParams['percision']}
            />
        
        )

    } else if (displayType === 'QbAts') {

        return (

            <QbAts
                val={cellContent}
                percision={displayParams['percision']}
            />
        
        )

    } else if (displayType === 'TotalStatus') {

        return (

            <TotalStatus
                val={cellContent}
            />
        
        )

    } else if (displayType === 'AmericanOdds') {

        return (

            <AmericanOdds
                val={cellContent}
            />
        
        )

    } else if (displayType === 'AbrName') {

        return (

            <AbrName
                val={cellContent}
                rem={displayParams['rem']}
            />
        
        )

    } else if (displayType === 'None') {

        return (

            cellContent
        
        )

    } else if (displayType === 'TeamArray') {

        return (

            <TeamArray
                val={cellContent}
            />
        
        )

    } else if (displayType === 'ImageArray') {

        return (

            <ImageArray
                val={cellContent}
                imageType={displayParams['imageType']}
            />
        
        )

    } else if (displayType === 'ImageX') {

        return (

            <ImageX
                val={cellContent}
                imageType={displayParams['imageType']}
            />
        
        )

    } else if (displayType === 'BettingAts') {

        return (

            <BettingAts
                val={cellContent}
                percision={displayParams['percision']}
            />
        
        )

    } else if (displayType === 'ActiveStatus') {

        return (

            <ActiveStatus
                val={cellContent}
            />
        
        )

    } else if (displayType === 'Rank32') {

        return (

            <Rank32
                val={cellContent}
                order={displayParams['order']}
            />
        
        )

    } else {

        return (
            <p>DISPLAY TYPE MISSING</p>
        )
    }

}

export default CellDisplay